<template>

    <v-navigation-drawer
        v-model="componentVisible"
        dark
        right
        fixed
        app
        clipped
        temporary
        width="450"
    >
        <v-tabs fixed centered dark v-model="active" color="white" slider-color="primary">

            <v-tab>
                Notifications ({{ notificationCount }})
            </v-tab>

            <v-tab>
                Announcements ({{ announcementCount }})
            </v-tab>

            <v-tab-item>
                <notifications-list :items="$store.state.notifications">
                    No notifications found
                </notifications-list>
            </v-tab-item>

            <v-tab-item>
                <announcements-list :items="$store.state.announcements">
                    No announcements found
                </announcements-list>
            </v-tab-item>
        </v-tabs>

    </v-navigation-drawer>
</template>

<script>

import notificationsList from './NotificationsList';
import announcementsList from './AnnouncementsList.vue';
import {mapState} from 'vuex';

export default {

    components: {
        notificationsList,
        announcementsList
    },

    data() {
        return {
            componentVisible: false,
            active: 0,
            queue: [],
            queueProcessing: false,
        }
    },

    created() {

        Bus.$on('announcements-drawer-toggle', () => {
            if (!this.componentVisible) this.selectCorrectTab();
            this.componentVisible = !this.componentVisible;
        });

        Bus.$on('announcements-drawer', (value) => {
            if (value) this.selectCorrectTab();
            this.componentVisible = value;
        });
    },

    computed: {

        ...mapState(['echo']),

        notificationCount() {
            if (this.$store.state.notifications) {
                return this.$store.state.notifications.length;
            }
            return 0;
        },

        announcementCount() {
            if (this.$store.state.announcements) {
                return this.$store.state.announcements.length;
            }
            return 0;
        },

        panelUuid() {
            if (this.$store.state.PanelSettings.settings.uuid) {
                return this.$store.state.PanelSettings.settings.uuid;
            }
        },
    },

    watch: {
        panelUuid(uuid) {
            this.joinAnnouncementChannel(uuid);
        }
    },

    mounted() {
        // Load initial messages
        this.$store.dispatch('loadMessages');
    },

    methods: {

        getFirstItemFromQueue() {
            if (this.queue.length > 0) {
                const item = this.queue[0];
                this.queue.splice(0, 1);
                return item;
            }
        },

        processQueue() {
            if (!this.queueProcessing) {

                this.queueProcessing = true;

                const item = this.getFirstItemFromQueue();

                if (item) {
                    this.$store.commit(item.commitAction, item.notification);
                    this.playAudio(item.audioFile, item.audioVolume);
                } else {
                    this.queueProcessing = false;
                }
            }
        },

        playAudio(file, volume) {

            if (file && volume) {

                let audio = new Audio(file);
                audio.volume = volume;
                audio.onended = () => {
                    this.queueProcessing = false;
                    this.processQueue();
                }
                audio.play();
            } else {
                this.queueProcessing = false;
                this.processQueue();
            }
        },

        addToNotificationQueue(commitAction, notification, audioFile, audioVolume) {

            if (this.queue.length > 3) {
                audioFile = null;
                audioVolume = null;
            }

            this.queue.push({
                commitAction: commitAction,
                notification: notification,
                audioFile: audioFile,
                audioVolume: audioVolume
            });

            this.processQueue();
        },

        joinAnnouncementChannel(panelUuid) {

            // Listen for events
            const channelName = 'Panel.' + panelUuid + '.User.' + this.$store.state.user.id;

            this.echo.private(channelName)

                .notification((notification) => {

                    if (notification.project_id) {

                        // Reload project automatically
                        if (this.$store.state.ProjectManager) {

                            this.$store.dispatch('ProjectManager/getProject', {
                                id: notification.project_id,
                                force: true
                            });
                        }
                    }

                    if (notification.type === 'App\\Notifications\\LiveProgressUpdate') {

                        Bus.$emit('live-progress', notification);

                    } else if (notification.type === 'App\\Notifications\\LiveErrorUpdate') {

                        Bus.$emit('live-error', notification);

                    } else if (notification.type === 'App\\Notifications\\Announcement') {

                        this.addToNotificationQueue('addAnnouncement', notification, '/sounds/announcement.mp3', 0.2)

                    } else if (notification.level === 'error') {
                        this.addToNotificationQueue('addNotification', notification, '/sounds/error.wav', 0.2)
                    } else if (notification.level === 'success') {
                        this.addToNotificationQueue('addNotification', notification, '/sounds/projectcomplete.wav', 0.2)
                    } else {
                        this.addToNotificationQueue('addNotification', notification, '/sounds/notification.wav', 0.2)
                    }
                });
        },

        selectCorrectTab() {
            if (this.notificationCount > 0) this.active = 0;
            if (this.announcementCount > 0) this.active = 1;
        }
    }
}

</script>
